import JQuery_Home from "./jquery_components/JQuery_Home.jsx";
import JQuery_Intro from "./jquery_components/JQuery_Intro.jsx";
import JQuery_Get_Started from "./jquery_components/JQuery_Get_Started.jsx";
import JQuery_Syntax from "./jquery_components/JQuery_Syntax.jsx";
import JQuery_Selectors from "./jquery_components/JQuery_Selectors.jsx";
import JQuery_Events from "./jquery_components/JQuery_Events.jsx";
import JQuery_Hide_Show from "./jquery_components/JQuery_Hide_Show.jsx";
import JQuery_Fade from "./jquery_components/JQuery_Fade.jsx";
import JQuery_Slide from "./jquery_components/JQuery_Slide.jsx";
import JQuery_Animate from "./jquery_components/JQuery_Animate.jsx";
import JQuery_Stop from "./jquery_components/JQuery_Stop.jsx";
import JQuery_Callback from "./jquery_components/JQuery_Callback.jsx";
import JQuery_Chaining from "./jquery_components/JQuery_Chaining.jsx";
import JQuery_Get from "./jquery_components/JQuery_Get.jsx";
import JQuery_Set from "./jquery_components/JQuery_Set.jsx";
import JQuery_Add from "./jquery_components/JQuery_Add.jsx";
import JQuery_Remove from "./jquery_components/JQuery_Remove.jsx";
import JQuery_CSS_Classes from "./jquery_components/JQuery_CSS_Classes.jsx";
import JQuery_CSS from "./jquery_components/JQuery_CSS.jsx";
import JQuery_Dimensions from "./jquery_components/JQuery_Dimensions.jsx";
import JQuery_Traversing from "./jquery_components/JQuery_Traversing.jsx";
import JQuery_Ancestors from "./jquery_components/JQuery_Ancestors.jsx";
import JQuery_Descendants from "./jquery_components/JQuery_Descendants.jsx";
import JQuery_Siblings from "./jquery_components/JQuery_Siblings.jsx";
import JQuery_Filtering from "./jquery_components/JQuery_Filtering.jsx";
import JQuery_AJAX_Intro from "./jquery_components/JQuery_AJAX_Intro.jsx";
import JQuery_Load from "./jquery_components/JQuery_Load.jsx";
import JQuery_Get_Post from "./jquery_components/JQuery_Get_Post.jsx";
import JQuery_NoConflict from "./jquery_components/JQuery_NoConflict.jsx";
import JQuery_Filters from "./jquery_components/JQuery_Filters.jsx";
import JQuery_Examples from "./jquery_components/JQuery_Examples.jsx";
import JQuery_Editor from "./jquery_components/JQuery_Editor.jsx";
import JQuery_Quiz from "./jquery_components/JQuery_Quiz.jsx";
import JQuery_Exercises from "./jquery_components/JQuery_Exercises.jsx";
import JQuery_Syllabus from "./jquery_components/JQuery_Syllabus.jsx";
import JQuery_Study_Plan from "./jquery_components/JQuery_Study_Plan.jsx";
import JQuery_Certificate from "./jquery_components/JQuery_Certificate.jsx";
import JQuery_Overview from "./jquery_components/JQuery_Overview.jsx";
import JQuery_Reference_Selectors from "./jquery_components/JQuery_Reference_Selectors.jsx";
import JQuery_Reference_Events from "./jquery_components/JQuery_Reference_Events.jsx";
import JQuery_Reference_Effects from "./jquery_components/JQuery_Reference_Effects.jsx";
import JQuery_Reference_HTML_CSS from "./jquery_components/JQuery_Reference_HTML_CSS.jsx";
import JQuery_Reference_Traversing from "./jquery_components/JQuery_Reference_Traversing.jsx";
import JQuery_Reference_AJAX from "./jquery_components/JQuery_Reference_AJAX.jsx";
import JQuery_Reference_Misc from "./jquery_components/JQuery_Reference_Misc.jsx";
import JQuery_Reference_Properties from "./jquery_components/JQuery_Reference_Properties.jsx";

const jqueryComponentsMap = {
  "<JQuery_Home />": JQuery_Home,
  "<JQuery_Intro />": JQuery_Intro,
  "<JQuery_Get_Started />": JQuery_Get_Started,
  "<JQuery_Syntax />": JQuery_Syntax,
  "<JQuery_Selectors />": JQuery_Selectors,
  "<JQuery_Events />": JQuery_Events,
  "<JQuery_Hide_Show />": JQuery_Hide_Show,
  "<JQuery_Fade />": JQuery_Fade,
  "<JQuery_Slide />": JQuery_Slide,
  "<JQuery_Animate />": JQuery_Animate,
  "<JQuery_Stop />": JQuery_Stop,
  "<JQuery_Callback />": JQuery_Callback,
  "<JQuery_Chaining />": JQuery_Chaining,
  "<JQuery_Get />": JQuery_Get,
  "<JQuery_Set />": JQuery_Set,
  "<JQuery_Add />": JQuery_Add,
  "<JQuery_Remove />": JQuery_Remove,
  "<JQuery_CSS_Classes />": JQuery_CSS_Classes,
  "<JQuery_CSS />": JQuery_CSS,
  "<JQuery_Dimensions />": JQuery_Dimensions,
  "<JQuery_Traversing />": JQuery_Traversing,
  "<JQuery_Ancestors />": JQuery_Ancestors,
  "<JQuery_Descendants />": JQuery_Descendants,
  "<JQuery_Siblings />": JQuery_Siblings,
  "<JQuery_Filtering />": JQuery_Filtering,
  "<JQuery_AJAX_Intro />": JQuery_AJAX_Intro,
  "<JQuery_Load />": JQuery_Load,
  "<JQuery_Get_Post />": JQuery_Get_Post,
  "<JQuery_NoConflict />": JQuery_NoConflict,
  "<JQuery_Filters />": JQuery_Filters,
  "<JQuery_Examples />": JQuery_Examples,
  "<JQuery_Editor />": JQuery_Editor,
  "<JQuery_Quiz />": JQuery_Quiz,
  "<JQuery_Exercises />": JQuery_Exercises,
  "<JQuery_Syllabus />": JQuery_Syllabus,
  "<JQuery_Study_Plan />": JQuery_Study_Plan,
  "<JQuery_Certificate />": JQuery_Certificate,
  "<JQuery_Overview />": JQuery_Overview,
  "<JQuery_Reference_Selectors />": JQuery_Reference_Selectors,
  "<JQuery_Reference_Events />": JQuery_Reference_Events,
  "<JQuery_Reference_Effects />": JQuery_Reference_Effects,
  "<JQuery_Reference_HTML_CSS />": JQuery_Reference_HTML_CSS,
  "<JQuery_Reference_Traversing />": JQuery_Reference_Traversing,
  "<JQuery_Reference_AJAX />": JQuery_Reference_AJAX,
  "<JQuery_Reference_Misc />": JQuery_Reference_Misc,
  "<JQuery_Reference_Properties />": JQuery_Reference_Properties,
};

export default jqueryComponentsMap;
